module.exports={"login-screen":{title:"Hi there! Please Sign in",form:{username:"Email address or Username",password:"Password"}}};